export const WidthClasses = {
    WIDTH_AUTO: ['wf-w-auto'],
    WIDTH_XL: ['wf-w-80'],
    WIDTH_80: ['wf-mx-auto', 'wf-w-4/5'],
    WIDTH_91: ['wf-mx-auto'],
    WIDTH_1_5: ['wf-w-1/5'],
    WIDTH_4_5: ['wf-w-4/5'],
    WIDTH_FULL: ['wf-w-full'] 
}